<template>
    
    <b-container class="p-0">
        <b-row class="my-2 mx-0">
            <b-col>
                <h5 class="font-weight-bold">Import CSV</h5>
                <hr />
            </b-col>
        </b-row>
        <divalto-import />
        <b-button variant="primary" @click="downloadSampleFile()">
            Download Sample File
        </b-button>
    </b-container>
</template>
<script>

import {ModalMixin} from '@/mixins';
import config from '@/config/app.config'
import DivaltoImport from '@/components/forms/DivaltoImport';
export default {
    name: "ClientModal",
    mixins: [ModalMixin],
    components:{
        DivaltoImport
    },
    data(){
        return {

        }
    },
    methods: {
        async downloadSampleFile(){
            await this.$store.dispatch('session/refresh')
            const token = this.$store.getters['session/currentToken']
            const apiUrl = `${config.API_BASE_URL}/divalto_codes/download_sample_csv?token=${token}`;
            window.location.href = apiUrl;
        }
    }
    
}
</script>

<style>
    .equipment-list .dropdown-menu{
        overflow: scroll;
        max-height: 50vh;
    }
    
    .equipment-list .dropdown-menu li+li{
        border-top: 1px solid #ccc;
    } 
    fieldset.form-group legend {
        text-transform: capitalize;
    }
</style>